import { useUserStore } from '@/store/app'
import { isProd } from '@/utils/environment'
import { getDeviceName } from '@/utils/device'

const sendEventBrevo = (eventName: string, params?: any) => {
  if (!isProd) return
  const userStore = useUserStore()
  if (userStore.user == null) return
  sendinblue.track(
    eventName,
    { ...params, source_email_marketing: 'kokoro-schools' },
    getMarketingUserProperties(
      userStore.user,
      userStore.childSelected == null ? userStore.user.children[0] : userStore.childSelected
    )
  )
}

const sendIdentifyBrevo = (user: any, child: any) => {
  if (!isProd) return
  sendinblue.identify(user.email, getMarketingUserProperties(user, child))
}

const sendPageBrevo = (params: any) => {
  if (!isProd) return
  sendinblue.page(params.to.name.toLowerCase(), {
    from: params.from.name.toLowerCase(),
    source: params.source,
    source_email_marketing: 'kokoro-schools',
    ma_title: params.to.name,
    ma_url: params.to.fullPath,
    ma_path: params.to.path
    /* ma_referrer: '' */
  })
}

const getMarketingUserProperties = (user: any, child: any) => {
  const userProperties = {
    // Attributes
    LOCALE: user.locale,
    USER_TYPE: user.type,
    NOMBRE: user.professionalName,
    LANDLINE_NUMBER: user.centerPhoneNumber,

    web_version: '2.0.0',
    web_platform: 'web',
    web_device_model: getDeviceName(),
    web_device_locale: navigator.language,
    web_locale: user.locale,
    email_notifications: user.emailNotification.toString(),
    push_notifications: user.pushNotification.toString(),
    user_id: user.id.toString(),
    user_locale: user.locale,
    user_type: user.type,
    user_neurodiversity: user.children
      .some((it: any) => {
        it.neurodiversity != null &&
          !it.neurodiversity.includes('NO') &&
          !it.neurodiversity.includes('NA') &&
          !it.neurodiversity.includes('NONE')
      })
      .toString(),
    user_children_ids: user.children.map((it: any) => it.id.toString()).join(','),
    user_children_names: user.children.map((it: any) => it.name).join(','),
    user_subscribed: user.subscription?.active.toString(),
    professional_name: user.professionalName,
    center_type: user.centerType,
    center_phone_number: user.centerPhoneNumber,
    child_id: child.id.toString(),
    child_name: child.name,
    child_birth: child.birth,
    child_locale: child.locale,
    child_stimuli: child.stimuli?.toString(),
    child_time: child.timeLimit?.toString(),
    child_time_limit: child.timeLimitSettings?.timeLimit.toString(),
    child_time_limit_left: child.timeLimitSettings?.timeLimitMinutesLeft.toString(),
    child_neurodiversity: child.neurodiversity?.join(',').toString(),
    child_sound: child.sound?.toString(),
    child_locution_volume: child.soundSettings?.locutionVolume.toString(),
    child_fx_volume: child.soundSettings?.musicFxVolume.toString()
  }

  if (user.subscription == null) return userProperties

  return {
    ...userProperties,
    SUBSCRIBED: user.subscription?.active,
    SUBSCRIPTION_TYPE: user.subscription?.productId
  }
}

export { sendEventBrevo, sendIdentifyBrevo, sendPageBrevo }
